import { IconButton, Theme } from '@mui/material';
import styled from 'styled-components';

import {
  getSizeStyles,
  getVariantStyles,
} from '@/shared/components/ui/button/common/button-common.styled';
import { TStyledButtonProps } from '@/shared/components/ui/button/common/button-common.types';

export const StyledIconBgButton = styled(IconButton)<TStyledButtonProps>`
  && {
    ${({ theme, $size = 'medium' }) =>
      getSizeStyles(theme as Theme)({ $size })};

    ${({ $variant = 'primary', theme, $clicked }) =>
      getVariantStyles(theme as Theme, $variant)({ $clicked })}

    &:disabled {
      opacity: 0.28;
    }
  }
`;
